import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/stats";

export default function HowItWorks() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24" aria-labelledby="how-it-works">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            id="how-it-works"
            eyebrow="征集流程"
            title="一条线索，如何走到真相"
            description="我们把线索征集拆成清晰的四个环节，每一步都可追溯、可沟通，让提供者知道自己的信息会如何被对待。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {processSteps.map((step, index) => (
            <Reveal key={step.step} delay={index * 90}>
              <div className="relative flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                    <i className={`${step.icon} text-xl`} />
                  </span>
                  <span className="font-heading text-2xl font-bold text-background-500">{step.step}</span>
                </div>
                <h3 className="mt-5 font-heading text-base font-bold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}